import { t } from "i18next";

type PtBrFiltersType =
  | "ACAO"
  | ""
  | "RENDA_FIXA"
  | "PREVIDENCIA"
  | "FUNDO"
  | "EUROPA";

/**
 * Translates category key into asset type name
 * @param category - Provides translations for assetTypes
 * @returns the translated name of assetType
 */
export const translateCategory = (
  category: PtBrFiltersType | string | null | undefined
): string => {
  switch (category) {
    case "ACAO":
      return t("searchAsset.stocks");
    case "FUNDO":
    case "EUROPA":
      return t("searchAsset.funds");
    case "RENDA_FIXA":
      return t("searchAsset.fixedIncome");
    case "PREVIDENCIA":
      return t("searchAsset.pension");
    case "Dólar":
      return t("benchmarkButton.dolar");
    default:
      return String(category);
  }
};
